module.exports = __webpack_public_path__ + "static/media/footwear-5.8f514d4b.jpg";